
<template>
    <div>
        <input type="hidden" name="_token" v-model="csrf">
    </div>
</template>

<script>
	export default {
		computed: {
			csrf: function() {
				let token = document.head.querySelector('meta[name="csrf-token"]');

				return token.content;
			}
		}
	};
</script>
